import validate from "/app/node_modules/.pnpm/nuxt@4.6.0_3be17c5ec8c5a2410f443b077286cf75/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.6.0_3be17c5ec8c5a2410f443b077286cf75/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "dev-only": () => import("/app/app/middleware/dev-only.ts")
}